import { Layout } from "antd"

const { Content } = Layout

const Body = ({ children }) => {
  return (
    <Content id="main-content" tabIndex={-1} className="app-shell__content">
      <div className="main-content">{children}</div>
    </Content>
  )
}

export default Body